// Centralised social links — update here to roll out across header/footer/home.
export const INSTAGRAM_URL = "https://www.instagram.com/africaartmasters/";
export const INSTAGRAM_HANDLE = "@africaartmasters";
